import * as React from 'react';
import {RouteChildrenProps} from 'react-router-dom';
import {Field} from '@practicegenius/react-final-form/src/Field';
import {FormScreen} from '../../../components/screens/FormScreen';
import {bottomText} from '../layout';
import {loginWithOauthAccessTokens, resetPassword} from '../../../http/login';
import {CreatePasswordInput} from '../../../components/CreatePasswordInput';
import {withQueryParams} from '../../../shared/utils/queryParams';
import {routes} from '../routes';
import {CrappyValidationException} from '../../../http/exceptions';

function isInvalidTokenError(error: Error): boolean {
  return error instanceof CrappyValidationException && 'token' in error.errors;
}

class ForgotPasswordReset extends React.Component<
  RouteChildrenProps & {
    resetPassword: typeof resetPassword;
    token: string;
  }
> {
  static defaultProps = {
    resetPassword,
  };

  resetPassword = async ({password}: {password: string}) => {
    try {
      const authorization = await this.props.resetPassword({
        password,
        password_confirmation: password,
        token: this.props.token,
      });

      const {redirect} = await loginWithOauthAccessTokens(authorization);

      this.props.history.push(routes.login.passwordResetSuccess, {redirect});
    } catch (error) {
      if (isInvalidTokenError(error as Error)) {
        throw new CrappyValidationException({
          password:
            'Invalid password reset link.  Please start over and request a new one.',
        });
      }

      throw error;
    }
  };

  render() {
    return (
      <FormScreen
        helmetTitle="Reset Password"
        submit={this.resetPassword}
        submitText="Next"
        initialValues={{password: ''}}
        headerTitle="Forgot Password"
        title="Reset Password"
        instructions="Your password must be a minimum of 8 characters."
        bottomText={bottomText('password')}
      >
        <Field name="password">
          {({input, meta}) => (
            <CreatePasswordInput {...input} error={meta.displayError} />
          )}
        </Field>
      </FormScreen>
    );
  }
}

export default withQueryParams(({token}) => ({token}))(ForgotPasswordReset);
